export const isAdmin = (formId:string) => {
    const adminIds = localStorage.getItem('access_token')
		? JSON.parse(localStorage.getItem('access_token') || '')?.user?.form_admin_list
		: []

    return adminIds.includes(formId)
}